/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { UserDocument } from './UserDocument'
import {
  UserDocumentFromJSON,
  UserDocumentFromJSONTyped,
  UserDocumentToJSON,
} from './UserDocument'
import type { UserDocumentFolder } from './UserDocumentFolder'
import {
  UserDocumentFolderFromJSON,
  UserDocumentFolderFromJSONTyped,
  UserDocumentFolderToJSON,
} from './UserDocumentFolder'

/**
 *
 * @export
 * @interface GetUserDocumentItem200ResponseData
 */
export interface GetUserDocumentItem200ResponseData {
  /**
   *
   * @type {UserDocumentFolder}
   * @memberof GetUserDocumentItem200ResponseData
   */
  folder: UserDocumentFolder
  /**
   *
   * @type {Array<UserDocument>}
   * @memberof GetUserDocumentItem200ResponseData
   */
  documents: Array<UserDocument>
}

/**
 * Check if a given object implements the GetUserDocumentItem200ResponseData interface.
 */
export function instanceOfGetUserDocumentItem200ResponseData(
  value: object
): value is GetUserDocumentItem200ResponseData {
  if (!('folder' in value) || value['folder'] === undefined) return false
  if (!('documents' in value) || value['documents'] === undefined) return false
  return true
}

export function GetUserDocumentItem200ResponseDataFromJSON(
  json: any
): GetUserDocumentItem200ResponseData {
  return GetUserDocumentItem200ResponseDataFromJSONTyped(json, false)
}

export function GetUserDocumentItem200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetUserDocumentItem200ResponseData {
  if (json == null) {
    return json
  }
  return {
    folder: UserDocumentFolderFromJSON(json['folder']),
    documents: (json['documents'] as Array<any>).map(UserDocumentFromJSON),
  }
}

export function GetUserDocumentItem200ResponseDataToJSON(
  value?: GetUserDocumentItem200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    folder: UserDocumentFolderToJSON(value['folder']),
    documents: (value['documents'] as Array<any>).map(UserDocumentToJSON),
  }
}
